import Vue from "vue";
import { errorServeiceHandler, makeQueryStringDync, makeQueryFormDataDyn } from "../helper";
const state = {
};
const getters = {
};
const mutations = {
};
const actions = {
  actPostInit: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/payment/init", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  actPayMobikwik: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + '/subscriber/v1/payment/wallet', {
        method: 'POST',
        body: data
      })
        .then(errorServeiceHandler)
        .then((response) => {
          return response.json()
        }).then((data) => {
          resolve(data)
        }).catch((error) => {
          reject(error);
        });
    });
  },
  actPayLazyPay: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      console.log(payload);
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + '/subscriber/v1/lazypay/eligibility', {
        method: 'POST',
        body: data
      })
        .then(errorServeiceHandler)
        .then((response) => {
          return response.json()
        }).then((data) => {
          resolve(data)
        }).catch((error) => {
          reject(error);
        });
    });
  },
  getPackDetails: (context, filterData) => {
    let url = '/subscriber/v1/subscriber/ldrprice'
    return new Promise( (resolve, reject) => {
      fetch(context.getters.baseUrl + url, {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        resolve(data)
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve({
            "chargeperiod": 1,
            "monthlyprice": 871.77,
            "quarterlyprice": 2615.32,
            "halfyearlyprice": 4794.75,
            "yearlyprice": 9589.49
        })
          return
        }
        reject(error)
      });
    });
  }

};

export default {
  actions, state, getters, mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/topUp.js